/**
 * The shared section title — one `h2` styling so every section that carries a
 * heading reads with the same rhythm (spec 42 · design 43). Class-free like the
 * rest of this package (see `index.ts`).
 */
import type { ReactNode } from "react";

export function SectionHeading({
  children,
  align = "center",
}: {
  children: ReactNode;
  align?: "left" | "center";
}) {
  return (
    <h2
      style={{
        fontFamily: "var(--font-display)",
        fontWeight: 500,
        fontSize: "1.5rem",
        color: "var(--ink)",
        margin: 0,
        marginBottom: "1.25rem",
        textAlign: align,
      }}
    >
      {children}
    </h2>
  );
}
